import { useEffect } from 'react'

const siteUrl = 'https://paprejatechsolutions.com'

function SEO({ title, description, path = '/' }) {
  useEffect(() => {
    document.title = title

    const setMeta = (name, content, attribute = 'name') => {
      let element = document.head.querySelector(`meta[${attribute}="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attribute, name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    setMeta('description', description)
    setMeta('og:title', title, 'property')
    setMeta('og:description', description, 'property')
    setMeta('og:type', 'website', 'property')
    setMeta('og:url', `${siteUrl}${path}`, 'property')
    setMeta('twitter:card', 'summary', 'name')
    setMeta('twitter:title', title, 'name')
    setMeta('twitter:description', description, 'name')

    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', `${siteUrl}${path}`)
  }, [description, path, title])

  return null
}

export default SEO
